import DatePickerInput from '../../../../lib/DatePicker';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import SegmentedControl from '../../../common/segmented-control';
import { getNewSchemeDetail } from '../../../../redux-store/actions/commercialTransactions';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    FormControl,
    FormControlLabel,
    FormHelperText,
    MenuItem,
    Select,
    SwipeableDrawer,
    TextField,
} from '@material-ui/core';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import { ArnPayloadType, PaymentTypes } from '../ExploreMFs/types';
import { validateArn } from '../../../../redux-store/actions/newPurchase';
import { consolidateErrors, getSipDays } from '../ExploreMFs/mf-helpers';
import { useEffect, useRef, useState } from 'react';
import en from '../../../../lang/en-us';
import { CustomRadio } from '../../../../lib/CustomRadio';
import {
    calculateInstallment,
    formatRtaResponse,
    getFoliosFromAmc,
    getValueForAddPurchase,
    handleCalendarView,
    isFolioNew,
    isSipAllowed,
    MAX_DATE,
    sortSip,
    TRXN_TYPE_MAP,
} from '../utils';
import { getFundTransactionInfo } from '../../../../redux-store/actions/commercialTransactions';
import { getInvestorLatestDetails } from '../../../../redux-store/actions/commercialTransactions';
import { connect, useSelector, useDispatch } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { getCountries } from '../../../../redux-store/actions/link';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';

import {
    CLEAR_SCHEME_INFO,
    SET_SCHEME_INFO,
    SET_SCHEME_PLAN,
} from '../../../../redux-store/types/newPurchase';
import { makeAdditionalPurchase } from '../../../../redux-store/actions/newPurchase';
import {
    DEFAULT_MAX_INVESTMENT,
    DEFAULT_MIN_TAT,
    getDateString,
    isMobileDevice,
    OTM_MAX_DATE,
    OTP_ACTIONS,
} from '../../../../utils/constants';
import { showHintTemplateForMaxAndMin } from '../ExploreMFs/Validations';
import { portfoliosByPurchaseAllow, portfoliosByReinvestment } from '../../portfolios/utils';
import { IsAllow, PlanTypes, SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import { favLogos } from '../../../../logo/logos';
import { API_KEYS, UI_KEYS, PurchaseInputField } from '../ExploreMFs/mf-helpers';
import useSip, { freqType } from '../../../../hooks/useSip';
import { DisplayBlock } from '../Redemption/HelperBlocks';
import { SelectBank } from '../Redemption/SelectBank';
import { bankDetailsInitState, BankDetailsType } from '../../../../hooks/useBank';
import {
    endDateDisable,
    formatWeekdayDisplay,
    getAllowedSipMonthDays,
    getAllowedSipWeekdays,
    isMotilalSipEndDateDisabled,
    isMotilalSipStartDateDisabled,
    isWeekdayNamedArray,
    startDateDisable,
} from '../utils';
import { isMotilalWeekly, MOTILAL_WEEKLY_DAYS } from '../../../../hooks/motilalSipHelpers';
import {
    AmountType,
    sipType,
    _schemeDetailsNewType,
} from '../../../../redux-store/types/commercialTransactions';
import { MAX_LENGTHS, MIN_LENGHTHS } from '../Switch/types';
import { KYCCheck } from '../../../common/KYCCheck';
import { CommercialRootPath } from '../routeConfig';
import { apDividendFilters } from './types';
import { SET_EUIN_CHECKED } from '../../../../redux-store/types/newPurchase';
import FatcaCheck from '../../../common/FatcaCheck';
import { SET_IS_FROM_PRE_LOGIN } from '../../../../redux-store/types/login';
import { IFSCError } from '../IFSCError';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
import { isWeekend } from 'date-fns';
import { rtaNames } from '../../../common/FatcaCheck.types';
import { NIPPON_MAX_AMOUNT } from '../ExploreMFs/mf-investment';
import NavDialog from '../ExploreMFs/nav-dialog';
import { NomineePopup } from '../../NomineePopup';

const { dbCommercial, common } = en;
const SEGMENTS = [dbCommercial.exploreMfs.Lumpsum, dbCommercial.exploreMfs.Sip];

type errorType = {
    dateError: boolean;
    [API_KEYS.EUI_FLAG]: boolean;
    [API_KEYS.ARN]: boolean;
    // [API_KEYS.SUB_BROKER_CODE]: boolean;
    [API_KEYS.AMOUNT]: boolean;
    // [API_KEYS.SUB_ARN]: boolean;
    [API_KEYS.RIA_CODE]: boolean;
    [API_KEYS.EUI_NO]: boolean;
};

export const isRegular = (schemePlan: any) => {
    return [PlanTypes.R, PlanTypes.Reggular].includes(schemePlan?.toUpperCase());
};

function ApInvestment(props: any) {
    const { additionalPurchaseFolio, sipFlag } = props.location.state || {};
    if (!additionalPurchaseFolio) {
        props.history.push('/');
        return null;
    }
    const amcCode = new URLSearchParams(props.location.search).get('amc') || undefined;
    const {
        schemeInfo = {},
        schemePlan = '',
        euinChecked: euinGlobal = IsAllow.No,
    }: any = useSelector(({ newPurchase }: RootStateType) => ({
        ...newPurchase,
    }));
    const [currentScheme, setScheme] = useState<typeof schemeInfo>(schemeInfo);
    const [euinChecked, setEuinChecked] = useState(euinGlobal);
    const [purchaseType, setPurchaseType] = useState(sipFlag ? SEGMENTS[1] : SEGMENTS[0]);
    const [loading, setLoading] = useState(false);
    const [ifscError, setIfscError] = useState(false);
    const [currentIsin, setIsin] = useState<string>('');
    const [investingThrough, setInvestingThrough] = useState<string | null>(
        [PlanTypes.D, PlanTypes.Direct].includes(
            additionalPurchaseFolio?.planMode?.toUpperCase(),
        ) || !additionalPurchaseFolio?.planMode //temporarily handling for planMode key not present
            ? schemeInfo.riaCode === ''
                ? 'direct'
                : 'ria'
            : 'distributor-arn',
    );
    const [folios, setFolios] = useState<Array<string>>([]);
    const [newPurchaseDetails, setNewPurchaseDetails] = useState<AmountType | null>(null);

    const brokerCode = useRef(additionalPurchaseFolio.brokerCode?.replace('ARN-', '') || '');
    brokerCode.current = brokerCode.current.search('-') === -1 ? brokerCode.current : '';

    const [errors, setErrors] = useState<errorType>({
        dateError: false,
        distId:
            isRegular(additionalPurchaseFolio?.planMode) &&
            (brokerCode.current.length < MIN_LENGHTHS.ARN_LENGTH ||
                brokerCode.current.length > MAX_LENGTHS.ARN_LENGTH),
        euin: isRegular(additionalPurchaseFolio?.planMode),
        euinDeclarationFlag: isRegular(additionalPurchaseFolio?.planMode),
        riaCode: !isRegular(additionalPurchaseFolio?.planMode) && investingThrough === 'ria',
        amount: true,
    });
    const [activeHandle, setActiveHandle] = useState<boolean>(false);
    const [perpetual, setPerpetual] = useState(false);
    const [touched, setTouched] = useState<any>({});
    const [sipDetails, setSipDetails] = useState<sipType | null>(null);
    const [addPurchaseDetails, setAddPurchaseDetails] = useState<AmountType | null>(null);
    const [commonDetails, setCommonDetails] =
        useState<_schemeDetailsNewType['commonDetails'] | null>(null);
    const [bankDetails, setBankDetails] = useState<BankDetailsType>(bankDetailsInitState);
    const [isChecked, setChecked] = useState<{ value: boolean; message: string }>({
        value: false,
        message: '',
    });
    const [showNavDialog, setShowNavDialog] = useState(false);
    const dispatch = useDispatch();

    const [currentInstallment, setInstallment] = useState<any>(
        !!sipDetails && currentScheme?.frequency
            ? (sipDetails[currentScheme?.frequency as string]?.minimumInstallments || [])[0]
                  ?.minAmount
            : 1,
    );
    const [startDate, endDate, setStartDate, setEndDate, resetEndDate, installment_diff] = useSip({
        frequencyType: currentScheme.frequency || 'Monthly',
        numInstallments: currentInstallment,
        sipDay: currentScheme.sipDay,
        kfinFlag: additionalPurchaseFolio?.rtaName === rtaNames.KFIN,
        sipTat:
            !!sipDetails && !!Number(sipDetails[currentScheme?.frequency as string]?.minSipTat)
                ? Number(sipDetails[currentScheme.frequency as string]?.minSipTat)
                : DEFAULT_MIN_TAT,
        setErrors,
        perpetual,
        amc: additionalPurchaseFolio?.amc,
        applyMotilalRules: true,
        allowedSipWeekdays: getAllowedSipWeekdays(
            sipDetails?.[currentScheme?.frequency as string]?.dates || [],
        ),
        allowedSipMonthDays: getAllowedSipMonthDays(
            sipDetails?.[currentScheme?.frequency as string]?.dates || [],
        ),
    });
    const handleSegmentChange = (selectedSegmentIndex: number) => {
        setPurchaseType(SEGMENTS[selectedSegmentIndex]);
    };

    const [schemeLoading, setSchemeLoading] = useState(false);
    const [checkPanSeed, setCheckPanSeed] = useState(false);

    useEffect(() => {
        let installmentKey =
            !!sipDetails &&
            currentScheme?.frequency &&
            sipDetails[currentScheme?.frequency as string]?.minimumInstallments[
                calculateInstallment(installment_diff, sipDetails, currentScheme)
            ];
        setInstallment(!!installmentKey ? installmentKey.installment : 1);
        const isMotilalWeeklyFlow = isMotilalWeekly(
            additionalPurchaseFolio?.amc,
            currentScheme?.frequency,
        );
        setScheme((prev: any) => ({
            ...prev,
            sipDay: isMotilalWeeklyFlow
                ? MOTILAL_WEEKLY_DAYS[0].value
                : getSipDays(
                      !!sipDetails
                          ? sipDetails[
                                !!currentScheme.frequency ? currentScheme.frequency : 'Monthly'
                            ]?.dates || []
                          : [],
                  )[0],
        }));
        setErrors((prev: errorType) => ({
            ...prev,
            amount: true,
        }));
        setTouched((prev: errorType) => ({
            ...prev,
            amount: false,
        }));
    }, [currentScheme?.frequency, sipDetails]);

    useEffect(() => {
        setTouched((prev: any) => ({ ...prev, amount: false }));
        setErrors((prev: any) => ({ ...prev, [API_KEYS.AMOUNT]: true }));
        setScheme((prev: any) => ({ ...prev, sipType: purchaseType, amount: 0 }));
    }, [purchaseType]);

    useEffect(() => {
        !!perpetual ? setEndDate(OTM_MAX_DATE(startDate)) : resetEndDate();
    }, [perpetual, startDate]);

    const handleInvest = (options: any) => {
        async function schemeAPICall(values: any = {}) {
            try {
                const { riaFlag, ...rest } = currentScheme;
                const apiData = {
                    reqId: '12345',
                    data: [
                        {
                            instNo: '',
                            omUMRN: '',
                            mandateRefId: '',
                            payInMode: '',
                            payInRefno: '',
                            payInBankName: '',
                            payInBankAcno: '',
                            tpvFlag: '',
                            amc: additionalPurchaseFolio?.amc,
                            schemeOptions: [
                                {
                                    ...rest,
                                    riaCode:
                                        currentScheme.riaCode === ''
                                            ? ''
                                            : `${riaFlag}${currentScheme.riaCode}`,
                                    isin: additionalPurchaseFolio?.isin || '',
                                    distId:
                                        !isRegular(additionalPurchaseFolio?.planMode) &&
                                        investingThrough === 'direct'
                                            ? 'DIRECT'
                                            : '',
                                    folio: currentScheme.folio.toString(),
                                    reInvest:
                                        !!commonDetails &&
                                        commonDetails.isDividend.toLowerCase() === 'false'
                                            ? 'Z'
                                            : portfoliosByReinvestment(additionalPurchaseFolio)
                                            ? 'Y'
                                            : 'N',
                                    trxnType: purchaseType === PaymentTypes.Lumpsum ? 'AP' : 'ASIP',
                                    startDate:
                                        purchaseType === PaymentTypes.Lumpsum
                                            ? ''
                                            : getDateString(startDate),
                                    endDate:
                                        purchaseType === PaymentTypes.Lumpsum
                                            ? ''
                                            : getDateString(endDate),
                                    frequency:
                                        purchaseType === PaymentTypes.Lumpsum
                                            ? ''
                                            : currentScheme.frequency,
                                    maxSipTat: !!sipDetails
                                        ? purchaseType === PaymentTypes.SIP
                                            ? sipDetails[currentScheme.frequency as string]
                                                  ?.maxSipTat
                                            : ''
                                        : '',
                                    minSipTat: !!sipDetails
                                        ? purchaseType === PaymentTypes.SIP || !!sipFlag
                                            ? String(
                                                  sipDetails[currentScheme.frequency as string]
                                                      ?.minSipTat,
                                              )
                                            : ''
                                        : '',
                                    noOfInstallments:
                                        purchaseType === PaymentTypes.SIP
                                            ? String(installment_diff + 1)
                                            : '',
                                    registrationDate: getDateString(new Date()),
                                    registrationAmount: currentScheme.amount,
                                    sipType: purchaseType === PaymentTypes.SIP ? 'SIP' : '',
                                    sipDay:
                                        purchaseType === PaymentTypes.SIP
                                            ? isMotilalWeekly(
                                                  additionalPurchaseFolio?.amc,
                                                  currentScheme?.frequency,
                                              )
                                                ? String(startDate.getDate())
                                                : String(currentScheme.sipDay)
                                            : '',
                                    investorName: additionalPurchaseFolio?.investorName || '',
                                    email: additionalPurchaseFolio?.email || '',
                                    ...values,
                                },
                            ],
                            bank: bankDetails || {},
                            dpid: '',
                            source: isMobileDevice() ? 'mobile' : 'web',
                        },
                    ],
                };
                let response = await props.makeAdditionalPurchase(apiData);
                const { body = {} } = response;
                const { pending: success = [], reqId } = body;
                const [data = {}] = success;
                const apiPayload = {
                    ...apiData.data[0],
                    schemeName: commonDetails?.schemeName,
                    logoUrl: !!commonDetails
                        ? `/images/fav-logos/${favLogos[commonDetails.amc] || 'default'}.svg`
                        : `/images/fav-logos/default.svg`,
                    investorDetails: {
                        bank: bankDetails,
                    },
                };
                const otpPayload = {
                    reqId,
                    action: OTP_ACTIONS.additionalPurchase,
                };
                const res = await props.sendPhoneOTP(otpPayload);
                // props.history.push(`${CommercialRootPath}/${data.userTrxnNo}/${reqId}/payment`, {
                //     ...apiData,
                //     schemeName: schemeMaster.schemeName,
                //     logoUrl: `/images/fav-logos/${
                //         favLogos[schemeMaster.fundAmcCode] || 'default'
                //     }.svg`,
                //     investorDetails: {
                //         bank: bankDetails,
                //     },
                // });
                dispatch({ type: CLEAR_SCHEME_INFO });
                props.history.push(`${CommercialRootPath}/ap/verify-otp`, {
                    apiPayload,
                    reqId: res.body.reqId,
                    userTrxnNo: data.userTrxnNo,
                    folio: `${additionalPurchaseFolio?.folio}`,
                    otpRef: res.body.otpRef,
                });
            } catch (error: any) {
                alert(error.message);
            }
        }
        const validateArnFields = async (Values: ArnPayloadType) => {
            // let test: any = {
            //     amc: 'RMF',
            //     distId: 'ARN-1234',
            //     subDist: 'ARN-3456',
            //     subBrokerARN: '',
            //     euin: '',
            //     euinDeclarationFlag: 'N',
            //     riaCode: '',
            //     planCode: 'REGULAR',
            // };
            try {
                await dispatch(validateArn(Values));
            } catch (err: any) {
                throw err;
            }
        };
        async function callApi() {
            try {
                if (!currentScheme.folio.toString()) {
                    throw new Error(dbCommercial.additionalPurchase.errors.emptyFolio);
                }
                // Restricted scheme check on the target scheme
                if (!!commonDetails) {
                    if (
                        purchaseType === PaymentTypes.Lumpsum &&
                        commonDetails.purAllow === IsAllow.No
                    ) {
                        throw new Error('One time purchase is not allowed for this scheme');
                    }
                    if (
                        purchaseType === PaymentTypes.SIP &&
                        commonDetails.sipAllow === IsAllow.No
                    ) {
                        throw new Error('SIP is not allowed for this scheme');
                    }
                }
                if (purchaseType === PaymentTypes.SIP) {
                    if (
                        commonDetails?.amc === 'RMF' &&
                        commonDetails?.scheme.slice(0, 2) === 'SC'
                    ) {
                        if (Number(currentScheme?.amount) > NIPPON_MAX_AMOUNT) {
                            throw new Error('Amount cannot be greater than 200,000');
                        }
                    }
                }
                if (!bankDetails?.ifsc) {
                    setIfscError(true);
                    return;
                }
                if (
                    currentScheme.frequency === freqType.D ||
                    currentScheme.frequency === freqType.DZ
                ) {
                    const startDateDayOfWeek = startDate.getDay();
                    const endDateDayofWeek = endDate.getDay();
                    if (isWeekend(startDateDayOfWeek) || isWeekend(endDateDayofWeek)) {
                        throw new Error('Weekend Days cannot be selected for Daily Frequency');
                    }
                }
                if (purchaseType === SEGMENTS[1]) {
                    if (installment_diff % 1 !== 0 && !perpetual) {
                        throw new Error('Invalid Installment');
                    }
                    const expectedSipDay = isMotilalWeekly(
                        additionalPurchaseFolio?.amc,
                        currentScheme?.frequency,
                    )
                        ? startDate.getDay()
                        : startDate.getDate();
                    if (Number(currentScheme.sipDay) !== expectedSipDay) {
                        throw new Error('SIP day and start date are different');
                    }
                }
                const {
                    distId,
                    subDist,
                    subBrokerARN,
                    euin,
                    euinDeclarationFlag,
                    riaCode,
                    riaFlag,
                } = currentScheme;
                const Values = {
                    amc: additionalPurchaseFolio?.amc,
                    distId: !!distId ? `ARN-${distId}` : '',
                    subDist: !!subDist ? `${subDist}` : '',
                    subBrokerARN: !!subBrokerARN ? `ARN-${subBrokerARN}` : '',
                    euin: !!euin ? `E${euin}` : '',
                    euinDeclarationFlag,
                    riaCode: riaCode === '' ? '' : `${riaFlag}${riaCode}`,
                    planCode: additionalPurchaseFolio?.planMode,
                };
                setLoading(true);
                const shouldArnValidated =
                    [PlanTypes.R, PlanTypes.Reggular].includes(
                        additionalPurchaseFolio?.planMode?.toUpperCase(),
                    ) || investingThrough === 'ria';
                if (shouldArnValidated && !options?.nav) {
                    await validateArnFields(Values);
                }
                let { planCode, amc, ...arnValues } = Values;
                if (options?.nav) {
                    setShowNavDialog(true);
                    return;
                }
                await schemeAPICall(isRegular(planCode) ? arnValues : {});
            } catch (error: any) {
                alert(error.message);
            } finally {
                setLoading(false);
            }
        }

        if (!!isChecked.value) {
            callApi();
        } else {
            setChecked({ value: false, message: dbCommercial.errors.termsAndCondition });
        }
        // props.history.push('/portal/commercial/mf-cart');
    };
    const { data = [] } = props?.portfolios || {};

    useEffect(() => {
        setScheme(schemeInfo);
        setErrors((prev: errorType) => ({
            ...prev,
            distId:
                prev.distId &&
                !(
                    currentScheme.distId.length >= MIN_LENGHTHS.ARN_LENGTH &&
                    currentScheme.distId.length <= MAX_LENGTHS.ARN_LENGTH
                ),
            riaCode: prev.riaCode && currentScheme.riaCode.length !== MAX_LENGTHS.RIA_LENGTH,
            euin:
                prev.euin &&
                currentScheme.euin.length !== MAX_LENGTHS.EUIN_LENGTH &&
                euinChecked === IsAllow.YES,
            euinDeclarationFlag:
                prev.euinDeclarationFlag &&
                euinChecked === IsAllow.No &&
                !(currentScheme.euinDeclarationFlag === IsAllow.YES),
        }));
    }, [schemeInfo]);

    useEffect(() => {
        if (data && additionalPurchaseFolio) {
            setFolios(
                getFoliosFromAmc(
                    data,
                    additionalPurchaseFolio?.amc,
                    apDividendFilters.filter((f) => f !== portfoliosByPurchaseAllow),
                )?.folios || [],
            );
        }
    }, [data, additionalPurchaseFolio]);

    useEffect(() => {
        if (schemePlan === '' || props.history.action === 'PUSH') {
            dispatch({
                type: SET_SCHEME_PLAN,
                body: !!additionalPurchaseFolio?.planMode ? additionalPurchaseFolio?.planMode : '',
            });
        }
        async function getNewSchemeDetails() {
            try {
                setSchemeLoading(true);
                const { body = { data: {} as any } }: any = await props.getNewSchemeDetail({
                    isin: additionalPurchaseFolio.isin,
                    amcCode: !!amcCode ? amcCode : '',
                });
                if (body.data[0].activeFlag === IsAllow.No) {
                    setActiveHandle(true);
                }
                const details = formatRtaResponse(body.data);
                //[TODO: Add default values to SIP]
                const { sip = null, bool: sipAllow } = isSipAllowed(details.sip);
                sortSip(sip);
                setAddPurchaseDetails({
                    ...details.additionalPurchase,
                    multiples:
                        !details.additionalPurchase?.multiples ||
                        Number(details.additionalPurchase?.multiples) < 1
                            ? 1
                            : details.additionalPurchase?.multiples,
                });
                setNewPurchaseDetails({
                    ...details.freshPurchase,
                    multiples:
                        !details.freshPurchase?.multiples ||
                        Number(details.freshPurchase?.multiples) < 1
                            ? 1
                            : details.freshPurchase?.multiples,
                });
                setSipDetails(sip);
                setCommonDetails({
                    ...details.commonDetails,
                    sipAllow:
                        details.commonDetails.sipAllow === IsAllow.YES
                            ? sipAllow
                            : details.commonDetails.sipAllow,
                });
                setScheme((prevSchemeData: any) => ({
                    ...prevSchemeData,
                    ...schemeInfo,
                    folio: schemeInfo.folio
                        ? schemeInfo.folio
                        : additionalPurchaseFolio?.folio.toString(),
                    frequency: schemeInfo.frequency
                        ? schemeInfo.frequency
                        : Object.keys(details.sip)[0],
                    distId: brokerCode.current,
                }));
                setIsin(details.commonDetails.isin);
            } catch (err: any) {
                alert(err.message);
                props.history.goBack();
            } finally {
                setSchemeLoading(false);
            }
        }
        getNewSchemeDetails();
    }, []);
    const [installmentIndex, setInstallmentIndex] = useState(0);
    useEffect(() => {
        if (!!sipDetails) {
            setInstallmentIndex(calculateInstallment(installment_diff, sipDetails, currentScheme));
        }
    }, [installment_diff, currentScheme?.frequency]);

    const handleViewMore = () => {
        dispatch({
            type: SET_SCHEME_INFO,
            body: {
                ...currentScheme,
                riaCode: investingThrough === 'ria' ? currentScheme.riaCode : '',
                amount: '',
            },
        });
        dispatch({
            type: SET_EUIN_CHECKED,
            body: { euinChecked },
        });
        props.history.push(`/portal/commercial/${currentIsin}/explore`, {
            buttonDisable: true,
        });
    };

    const Lumpsum = (
        <div className="investment-amount">
            <p>{dbCommercial.exploreMfs.mfInvestment.lumpsumAmount}</p>
            <PurchaseInputField
                handleChange={setScheme}
                value={currentScheme}
                stateKey={API_KEYS.AMOUNT}
                showHelper={true}
                handleTouch={setTouched}
                uiKey="₹"
                maxLength={18}
                touched={touched}
                checkError={(value: string) => {
                    if (!addPurchaseDetails || !newPurchaseDetails) return false;
                    let step = 1;
                    const folioNotNew = !isFolioNew(data, currentScheme.folio);
                    if (!!addPurchaseDetails.multiples) {
                        if (folioNotNew) {
                            step = Number(addPurchaseDetails.multiples);
                        } else if (!!newPurchaseDetails.multiples) {
                            step = Number(newPurchaseDetails.multiples);
                        }
                    }
                    const _value = Number(value);
                    const minAmount = folioNotNew
                        ? addPurchaseDetails.minAmount
                        : newPurchaseDetails.minAmount;
                    return _value % Number(step) != 0 || _value < Number(minAmount);
                }}
                errorText={showHintTemplateForMaxAndMin({
                    min: getValueForAddPurchase(
                        data,
                        'minAmount',
                        newPurchaseDetails,
                        addPurchaseDetails,
                        currentScheme.folio,
                    ),
                    max: getValueForAddPurchase(
                        data,
                        'maxAmount',
                        newPurchaseDetails,
                        addPurchaseDetails,
                        currentScheme.folio,
                    ),
                    multiples: getValueForAddPurchase(
                        data,
                        'multiples',
                        newPurchaseDetails,
                        addPurchaseDetails,
                        currentScheme.folio,
                    ),
                })}
                handleError={setErrors}
            />
        </div>
    );
    const Sip = (
        <>
            <div className="investment-amount">
                <p>{dbCommercial.exploreMfs.mfInvestment.sipAmount}</p>
                <PurchaseInputField
                    handleChange={setScheme}
                    value={currentScheme}
                    touched={touched}
                    handleTouch={setTouched}
                    stateKey={API_KEYS.AMOUNT}
                    showHelper={true}
                    uiKey="₹"
                    maxLength={18}
                    checkError={(value: string) => {
                        if (!sipDetails) return false;
                        const sipData = sipDetails[currentScheme.frequency];
                        const minAmount =
                            sipData?.minimumInstallments[installmentIndex].minAmount || 1;
                        const maxAmount =
                            sipData?.minimumInstallments[installmentIndex].maxAmount ||
                            DEFAULT_MAX_INVESTMENT;
                        const step = !!sipData?.multiples ? sipData.multiples : 1;
                        return !(
                            (
                                Number(value) % Number(step) === 0 &&
                                Number(value) >= Number(minAmount)
                            )
                            // && Number(value) <= maxAmount
                        );
                    }}
                    errorText={
                        !!sipDetails
                            ? showHintTemplateForMaxAndMin({
                                  min:
                                      sipDetails[currentScheme.frequency]?.minimumInstallments[
                                          calculateInstallment(
                                              installment_diff,
                                              sipDetails,
                                              currentScheme,
                                          )
                                      ].minAmount || 1,
                                  max:
                                      sipDetails[currentScheme.frequency]?.minimumInstallments[
                                          calculateInstallment(
                                              installment_diff,
                                              sipDetails,
                                              currentScheme,
                                          )
                                      ].maxAmount || DEFAULT_MAX_INVESTMENT,
                                  multiples: sipDetails[currentScheme.frequency]?.multiples || 1,
                              })
                            : ''
                    }
                    handleError={setErrors}
                />
            </div>
            <div className="investment-amount-select">
                <FormControl variant="filled" className="mf-investment-select">
                    <p>{dbCommercial.exploreMfs.mfInvestment.frequency}</p>
                    <Select
                        labelId="frequency-label"
                        id="frequency"
                        value={currentScheme?.frequency || 'Monthly'}
                        onChange={(e: any) =>
                            setScheme({
                                ...currentScheme,
                                frequency: e.target.value,
                                amount: 0,
                            })
                        }
                    >
                        {!!sipDetails &&
                            Object.keys(sipDetails).map((option: string) => (
                                <MenuItem value={option}>{option}</MenuItem>
                            ))}
                    </Select>
                </FormControl>
                <FormControl variant="filled" className="mf-investment-select">
                    <p>{dbCommercial.exploreMfs.mfInvestment.selectSipDay}</p>
                    {additionalPurchaseFolio?.rtaName === rtaNames.KFIN &&
                    (currentScheme?.frequency === freqType.W ||
                        currentScheme?.frequency === freqType.F) &&
                    isWeekdayNamedArray(
                        sipDetails?.[currentScheme?.frequency || 'Monthly']?.dates || [],
                    ) ? (
                        <TextField
                            variant="filled"
                            className="mf-investment-select"
                            value={formatWeekdayDisplay(
                                sipDetails?.[currentScheme?.frequency || 'Monthly']?.dates || [],
                            )}
                            disabled
                        />
                    ) : (
                        <Select
                            labelId="select-sip-label"
                            id="select-sip"
                            value={currentScheme.sipDay || new Date().getDate()}
                            onChange={(e: any) =>
                                setScheme({
                                    ...currentScheme,
                                    sipDay: e.target.value,
                                })
                            }
                        >
                            {isMotilalWeekly(additionalPurchaseFolio?.amc, currentScheme?.frequency)
                                ? MOTILAL_WEEKLY_DAYS.map(({ value, label }) => (
                                      <MenuItem value={value}>{label}</MenuItem>
                                  ))
                                : !!sipDetails &&
                                  getSipDays(
                                      sipDetails[
                                          !!currentScheme.frequency
                                              ? currentScheme.frequency
                                              : 'Monthly'
                                      ]?.dates || [],
                                  )?.map((val: number) => <MenuItem value={val}>{val}</MenuItem>)}
                        </Select>
                    )}
                </FormControl>
            </div>
            <div className="sip-run-time">
                <DatePickerInput
                    className="sip-date-input"
                    label="Start Date"
                    value={startDate}
                    disableFuture={false}
                    disablePast={true}
                    maxDate={OTM_MAX_DATE(startDate)}
                    onChange={(e) => {
                        setStartDate(e || new Date());
                    }}
                    shouldDisableDate={(day: MaterialUiPickersDate) => {
                        if (
                            isMotilalWeekly(additionalPurchaseFolio?.amc, currentScheme?.frequency)
                        ) {
                            return isMotilalSipStartDateDisabled(
                                day,
                                currentScheme?.frequency,
                                additionalPurchaseFolio?.amc,
                                Number(currentScheme?.sipDay),
                            );
                        }
                        return (
                            startDateDisable(
                                day,
                                sipDetails,
                                currentScheme,
                                startDate,
                                false,
                                additionalPurchaseFolio?.rtaName === rtaNames.KFIN,
                            ) ||
                            isMotilalSipStartDateDisabled(
                                day,
                                currentScheme?.frequency,
                                additionalPurchaseFolio?.amc,
                            )
                        );
                    }}
                />
                <DatePickerInput
                    className="sip-date-input"
                    disablePast={true}
                    label="End Date"
                    value={endDate}
                    maxDate={OTM_MAX_DATE(startDate)}
                    disabled={perpetual}
                    onChange={(e) => {
                        console.log(e, 'value');
                        setEndDate(e || new Date());
                    }}
                    disableFuture={false}
                    error={!!errors.dateError}
                    helperText={`Minimum Installments is ${
                        !!sipDetails
                            ? sipDetails[currentScheme?.frequency || 0]?.minimumInstallments[
                                  calculateInstallment(installment_diff, sipDetails, currentScheme)
                              ].installment || 1
                            : 1
                    }`}
                    shouldDisableDate={(day: MaterialUiPickersDate) => {
                        if (
                            isMotilalWeekly(additionalPurchaseFolio?.amc, currentScheme?.frequency)
                        ) {
                            return (
                                !!day &&
                                (day.getDay() === 0 ||
                                    day.getDay() === 6 ||
                                    day.getDay() !== startDate.getDay() ||
                                    day > OTM_MAX_DATE(startDate))
                            );
                        }
                        return (
                            endDateDisable(
                                day,
                                sipDetails,
                                currentScheme,
                                startDate,
                                endDate,
                                false,
                                additionalPurchaseFolio?.rtaName === rtaNames.KFIN,
                            ) ||
                            isMotilalSipEndDateDisabled(
                                day,
                                startDate,
                                currentScheme?.frequency,
                                additionalPurchaseFolio?.amc,
                            ) ||
                            (!!day && day > OTM_MAX_DATE(startDate))
                        );
                    }}
                    views={
                        !!currentScheme.frequency
                            ? handleCalendarView(currentScheme.frequency)
                            : ['year', 'month', 'date']
                    }
                />
                <CheckBoxField
                    label="Perpetual(max 40 years)"
                    value={perpetual}
                    onChange={() => setPerpetual((prev) => !prev)}
                />
            </div>
        </>
    );
    const [show, setShow] = useState<boolean>(false);
    const [euin, setEuin] = useState<boolean>(false);
    const [openDrawer, setDrawer] = useState<boolean>(false);

    return (
        <div className="curved-bg mf-investment ap-investment">
            <KYCCheck
                allowRegistration={{
                    isin: additionalPurchaseFolio.isin,
                    amc: additionalPurchaseFolio.amc,
                }}
            />
            <PanSeedCheckNew
                foliosArray={[additionalPurchaseFolio]}
                trxnMode="FT"
                trxnType={
                    purchaseType === PaymentTypes.Lumpsum
                        ? TRXN_TYPE_MAP.additionalPurchase
                        : TRXN_TYPE_MAP.additionalPurchaseSip
                }
                callBackFn={() => {}}
                triggerCheck={true}
            />
            <FatcaCheck rtaName={additionalPurchaseFolio?.rtaName} />
            <div className="explore-mf-heading">
                <h2 className="heading">
                    <a
                        onClick={() => {
                            props.history.goBack();
                            dispatch({
                                type: CLEAR_SCHEME_INFO,
                            });
                        }}
                    >
                        <img src="/images/left-arrow-black.svg" alt="icon" />
                    </a>
                    <div className="mf-logo">
                        <img
                            src={`/images/fav-logos/${favLogos[additionalPurchaseFolio?.amc]}.svg`}
                            alt=""
                            className="list-logo"
                        />
                    </div>
                    {additionalPurchaseFolio?.schemeName}
                </h2>
                <div className="mobile-profile-details mobile_mode">
                    <div className="mobile-profile-details-inner">
                        <h4>{dbCommercial.additionalPurchase.investmentPage.rightHeading}</h4>
                        <div className="mobile-profile-details-links">
                            <a onClick={() => setDrawer(true)}>
                                View <img src="/images/right-arrow-purple.svg" alt="icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="curved-bg-content">
                <div className="mf-investment-left">
                    {!!folios && folios.length > 0 && (
                        <FormControl variant="outlined" className="mf-investment-select">
                            <Select
                                labelId="mf-scheme-label"
                                id="portfolio-sortby"
                                value={currentScheme.folio}
                                onChange={(e: any) => {
                                    setScheme((prevScheme: any) => {
                                        return {
                                            ...prevScheme,
                                            folio: e.target.value,
                                        };
                                    });
                                }}
                            >
                                {folios.map((folio: string) => (
                                    <MenuItem value={folio}>
                                        {folio}-{additionalPurchaseFolio?.investorName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    <br />
                    <div className="investment-mode">
                        <h3>
                            <img src="/images/investment-mode.svg" alt="icon" />
                            {dbCommercial.exploreMfs.mfInvestment.investmentMode}
                        </h3>
                        {[PlanTypes.R, PlanTypes.Reggular].includes(schemePlan?.toUpperCase()) ? (
                            <>
                                <div className="radio-div">
                                    <p>{dbCommercial.exploreMfs.mfInvestment.investingThrough}</p>
                                    <CustomRadio
                                        name="investing-through"
                                        list={[
                                            {
                                                label: 'Distributor (ARN)  ',
                                                value: 'distributor-arn',
                                            },
                                        ]}
                                        selectedValue="distributor-arn"
                                        handleRadioChange={(value: string) =>
                                            setInvestingThrough(value)
                                        }
                                    />
                                </div>
                                <div className="inputs-wrap">
                                    <PurchaseInputField
                                        label={dbCommercial.exploreMfs.mfInvestment.enterArn}
                                        handleChange={setScheme}
                                        maxLength={MAX_LENGTHS.ARN_LENGTH}
                                        value={currentScheme}
                                        stateKey={API_KEYS.ARN}
                                        uiKey={UI_KEYS.ARN}
                                        handleTouch={setTouched}
                                        touched={touched}
                                        checkError={(value: string) => {
                                            return (
                                                value.length < MIN_LENGHTHS.ARN_LENGTH ||
                                                value.length > MAX_LENGTHS.ARN_LENGTH
                                            );
                                        }}
                                        errorText={dbCommercial.additionalPurchase.errors.enterARN}
                                        handleError={setErrors}
                                    />
                                    <PurchaseInputField
                                        label={dbCommercial.exploreMfs.mfInvestment.subBrokerCode}
                                        handleChange={setScheme}
                                        value={currentScheme}
                                        maxLength={MAX_LENGTHS.SUB_BROKER_ARN_LENGTH}
                                        stateKey={API_KEYS.SUB_BROKER_CODE}
                                        uiKey="-"
                                    />
                                    <PurchaseInputField
                                        label={
                                            dbCommercial.exploreMfs.mfInvestment.subBrokerArnCode
                                        }
                                        handleChange={setScheme}
                                        value={currentScheme}
                                        maxLength={MAX_LENGTHS.SUB_BROKER_ARN_LENGTH}
                                        stateKey={API_KEYS.SUB_ARN}
                                        uiKey={UI_KEYS.SUB_ARN}
                                    />
                                </div>
                                <div className="radio-div">
                                    <p>{dbCommercial.exploreMfs.mfInvestment.euinNo}</p>
                                    <CustomRadio
                                        name="euin-no"
                                        list={[
                                            {
                                                label: dbCommercial.exploreMfs.mfInvestment.yes,
                                                value: IsAllow.YES,
                                            },
                                            {
                                                label: dbCommercial.exploreMfs.mfInvestment.no,
                                                value: IsAllow.No,
                                            },
                                        ]}
                                        selectedValue={euinChecked}
                                        handleRadioChange={(value: IsAllow) => {
                                            setEuinChecked(value);
                                            if (value === IsAllow.YES) {
                                                setScheme((prev: any) => {
                                                    return {
                                                        ...prev,
                                                        [API_KEYS.EUI_FLAG]: IsAllow.No,
                                                    };
                                                });
                                                setErrors((prev: any) => {
                                                    return {
                                                        ...prev,
                                                        [API_KEYS.EUI_FLAG]: false,
                                                        [API_KEYS.EUI_NO]: true,
                                                    };
                                                });
                                            } else {
                                                setScheme((prev: any) => {
                                                    return {
                                                        ...prev,
                                                        [API_KEYS.EUI_NO]: '',
                                                    };
                                                });
                                                setErrors((prev: any) => {
                                                    return {
                                                        ...prev,
                                                        [API_KEYS.EUI_FLAG]: true,
                                                        [API_KEYS.EUI_NO]: false,
                                                    };
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {euinChecked === IsAllow.YES && (
                                    <PurchaseInputField
                                        label="EUIN Number"
                                        handleChange={setScheme}
                                        value={currentScheme}
                                        stateKey={API_KEYS.EUI_NO}
                                        uiKey={UI_KEYS.EUI_NO}
                                        maxLength={6}
                                        handleTouch={setTouched}
                                        touched={touched}
                                        checkError={(value: string) => {
                                            return value.length !== 6;
                                        }}
                                        errorText={dbCommercial.additionalPurchase.errors.enterEUIN}
                                        handleError={setErrors}
                                    />
                                )}
                                {euinChecked === IsAllow.No && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(event) => {
                                                    setScheme((prev: any) => {
                                                        return {
                                                            ...prev,
                                                            [API_KEYS.EUI_FLAG]: event.target
                                                                .checked
                                                                ? IsAllow.YES
                                                                : IsAllow.No,
                                                        };
                                                    });
                                                    setErrors((prev: errorType) => {
                                                        return {
                                                            ...prev,
                                                            [API_KEYS.EUI_FLAG]:
                                                                !errors[API_KEYS.EUI_FLAG],
                                                        };
                                                    });
                                                }}
                                                onFocus={() => {
                                                    setTouched((prev: any) => ({
                                                        ...prev,
                                                        [API_KEYS.EUI_FLAG]: true,
                                                    }));
                                                }}
                                                checked={
                                                    currentScheme.euinDeclarationFlag ===
                                                    IsAllow.YES
                                                }
                                            />
                                        }
                                        label={
                                            <>
                                                {dbCommercial.exploreMfs.mfInvestment.iAgree}
                                                <a
                                                    onClick={() => setEuin(true)}
                                                    style={{ color: '#836fe0' }}
                                                >
                                                    {
                                                        dbCommercial.exploreMfs.mfInvestment
                                                            .euinDeclaration
                                                    }
                                                </a>
                                                <div style={{ color: 'red' }}>
                                                    {' '}
                                                    {!!errors[API_KEYS.EUI_FLAG] &&
                                                    !!touched[API_KEYS.EUI_FLAG]
                                                        ? 'Accept EUIN Declaration'
                                                        : null}
                                                </div>
                                            </>
                                        }
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                <div className="radio-div">
                                    <p>{dbCommercial.exploreMfs.mfInvestment.investingThrough}</p>
                                    <CustomRadio
                                        name="investing-through"
                                        list={[
                                            {
                                                label: 'Direct',
                                                value: 'direct',
                                            },
                                            {
                                                label: 'RIA',
                                                value: 'ria',
                                            },
                                        ]}
                                        selectedValue={investingThrough}
                                        handleRadioChange={(value: string) => {
                                            setInvestingThrough(value);
                                            if (value === 'direct') {
                                                setScheme((prev: any) => ({
                                                    ...prev,
                                                    [API_KEYS.RIA_CODE]: '',
                                                }));
                                                setErrors((prev: any) => ({
                                                    ...prev,
                                                    [API_KEYS.RIA_CODE]: false,
                                                }));
                                            } else {
                                                setErrors((prev: any) => ({
                                                    ...prev,
                                                    [API_KEYS.RIA_CODE]: true,
                                                }));
                                            }
                                        }}
                                    />
                                </div>
                                {investingThrough === 'ria' && (
                                    <div style={{ maxWidth: 300, width: '100%' }}>
                                        <PurchaseInputField
                                            label="RIA Code"
                                            handleChange={setScheme}
                                            value={currentScheme}
                                            stateKey={API_KEYS.RIA_CODE}
                                            uiKey={UI_KEYS.RIA_CODE}
                                            checkError={(value: string) => {
                                                return value.length !== 9;
                                            }}
                                            maxLength={9}
                                            errorText={
                                                dbCommercial.additionalPurchase.errors.enterRIA
                                            }
                                            touched={touched}
                                            handleTouch={setTouched}
                                            handleError={setErrors}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="investment-details">
                        <h3>
                            <img src="/images/investment-details.svg" alt="icon" />
                            {dbCommercial.exploreMfs.mfInvestment.investmentDetails}
                        </h3>
                        {additionalPurchaseFolio?.purAllow === IsAllow.YES &&
                            additionalPurchaseFolio?.sipAllow === IsAllow.YES &&
                            !sipFlag && (
                                <>
                                    <SegmentedControl
                                        additionalClasses="portfolio-details-tabs portfolio-demat-tabs"
                                        segments={['', '']}
                                        segmentsSpan={SEGMENTS}
                                        segmentsImage={[
                                            {
                                                active: 'inv-lumpsum-white.svg',
                                                inactive: 'inv-lumpsum.svg',
                                            },
                                            {
                                                active: 'inv-sip-white.svg',
                                                inactive: 'inv-sip.svg',
                                            },
                                        ]}
                                        onSegmentChanged={handleSegmentChange}
                                        selectedSegmentIndex={SEGMENTS.findIndex(
                                            (str: string) => str === purchaseType,
                                        )}
                                        key={purchaseType}
                                    />
                                    <div className="investment-details-content">
                                        {purchaseType === SEGMENTS[0] ? (
                                            Lumpsum
                                        ) : Object.keys(sipDetails || {}).length > 0 ? (
                                            Sip
                                        ) : (
                                            <div className="investment-amount">
                                                {dbCommercial.exploreMfs.mfInvestment.sipAllow}
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        <div className="investment-details-content">
                            {additionalPurchaseFolio?.sipAllow === IsAllow.YES &&
                            additionalPurchaseFolio?.purAllow === IsAllow.No ? (
                                Object.keys(sipDetails || {}).length > 0 ? (
                                    Sip
                                ) : (
                                    <div className="investment-amount">
                                        {dbCommercial.exploreMfs.mfInvestment.sipAllow}
                                    </div>
                                )
                            ) : null}
                            {additionalPurchaseFolio?.purAllow === IsAllow.YES &&
                            additionalPurchaseFolio?.sipAllow === IsAllow.YES &&
                            !!sipFlag ? (
                                Object.keys(sipDetails || {}).length > 0 ? (
                                    Sip
                                ) : (
                                    <div className="investment-amount">
                                        {dbCommercial.exploreMfs.mfInvestment.sipAllow}
                                    </div>
                                )
                            ) : null}
                            {additionalPurchaseFolio?.purAllow === IsAllow.YES &&
                                additionalPurchaseFolio?.sipAllow === IsAllow.No &&
                                Lumpsum}
                        </div>
                        <div className="mf-investment-bottom">
                            <div className="disclaimers">
                                <FormControl>
                                    <FormControlLabel
                                        className="inline-checkbox"
                                        control={
                                            <Checkbox
                                                name="terms-conditions"
                                                onChange={() =>
                                                    setChecked((prevState) => ({
                                                        value: !prevState.value,
                                                        message: !!prevState.value
                                                            ? dbCommercial.errors.termsAndCondition
                                                            : '',
                                                    }))
                                                }
                                                checked={isChecked.value}
                                                disabled={loading}
                                            />
                                        }
                                        label={
                                            <>
                                                {dbCommercial.exploreMfs.mfInvestment.disclaimers}
                                                <a onClick={() => setShow(!show)}>
                                                    {dbCommercial.exploreMfs.mfInvestment.termsLink}
                                                </a>
                                                {dbCommercial.exploreMfs.mfInvestment.of}
                                                <span>
                                                    {dbCommercial.exploreMfs.mfInvestment.mfCentral}
                                                </span>
                                            </>
                                        }
                                    />
                                    <FormHelperText
                                        style={{ color: 'red', fontSize: 14, textAlign: 'left' }}
                                    >
                                        {isChecked.message}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                            <div className="buttons">
                                <SubmitButtonWithLoader
                                    className="customBtn "
                                    label={dbCommercial.exploreMfs.mfInvestment.invest}
                                    labelWhileLoading="Submitting"
                                    loading={loading}
                                    onClick={() => handleInvest({ nav: true })}
                                    disabled={consolidateErrors(errors)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mf-investment-right mf-investment-right-2">
                    <div className="heading">
                        <h4>
                            {dbCommercial.additionalPurchase.investmentPage.rightHeading}
                            <a style={{ fontSize: 12 }} onClick={handleViewMore}>
                                {dbCommercial.additionalPurchase.investmentPage.viewMore}
                            </a>
                        </h4>
                        <div className="profile-details">
                            <DisplayBlock
                                title={dbCommercial.additionalPurchase.investmentPage.pan}
                                value={`${props.pan}`}
                            />
                            <div className="profile-details-info">
                                <h6> {`${additionalPurchaseFolio?.schemeName}`}</h6>
                            </div>
                        </div>
                        <SelectBank
                            amc={additionalPurchaseFolio?.amc}
                            folioNo={currentScheme.folio}
                            handleBankDetails={setBankDetails}
                        />
                    </div>
                </div>
                <IFSCError open={ifscError} setOpen={setIfscError} />
                <Dialog
                    onClose={() => props.history.goBack()}
                    maxWidth={'sm'}
                    open={activeHandle}
                    aria-labelledby="transmission-main-modal"
                >
                    <div className="note-modals transmission-main-modal">
                        <h3>{dbCommercial.exploreMfs.inactiveScheme}</h3>
                        <p>{dbCommercial.exploreMfs.inactiveSchemeInfo}</p>
                        <div className="note-modals-btns">
                            <Button className="customBtn" onClick={() => props.history.goBack()}>
                                {dbCommercial.exploreMfs.okay}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </div>
            <Dialog fullWidth maxWidth={'lg'} open={show} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.termsConditions}</h2>
                        <a className="close">
                            <img
                                onClick={() => setShow(!show)}
                                src="/images/close-white.svg"
                                alt="icon"
                            />
                        </a>
                    </div>
                    <div className="content-outer">
                        {/* Additional Purchase Content */}
                        {!sipFlag && (
                            <div className="content-inner">
                                <p>{dbCommercial.termsModal.additionalPurchase.info1}</p>
                                <p>{dbCommercial.termsModal.additionalPurchase.info2}</p>
                                <p>{dbCommercial.termsModal.additionalPurchase.info3}</p>
                                <a
                                    style={{ textDecoration: 'underline', color: '#836fe0' }}
                                    onClick={() => {
                                        window.open(`/fixtures/payment_matrix.pdf`, '_system');
                                    }}
                                >
                                    {dbCommercial.termsModal.additionalPurchase.info4}
                                </a>
                            </div>
                        )}
                        {/* SIP Content */}
                        {!!sipFlag && (
                            <div className="content-inner">
                                <p>{dbCommercial.termsModal.sip.info1}</p>
                                <p>{dbCommercial.termsModal.sip.info2}</p>
                                <p>{dbCommercial.termsModal.sip.info3}</p>
                                <a
                                    style={{ textDecoration: 'underline', color: '#836fe0' }}
                                    onClick={() => {
                                        window.open(`/fixtures/payment_matrix.pdf`, '_system');
                                    }}
                                >
                                    {dbCommercial.termsModal.additionalPurchase.info4}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>{' '}
            <Dialog fullWidth maxWidth={'lg'} open={euin} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.euinDeclaration}</h2>
                        <a className="close" onClick={() => setEuin(!euin)}>
                            <img src="/images/close-white.svg" alt="icon" />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.euinModal.info}</p>
                        </div>
                    </div>
                </div>
            </Dialog>
            <RtaSchemeLoadingDialog open={schemeLoading} />
            <SwipeableDrawer
                anchor={'bottom'}
                open={openDrawer}
                onClose={() => setDrawer(false)}
                onOpen={() => setDrawer(true)}
                className="explore-mf-drawer investment-details-drawer"
            >
                <div className="filters-drawer-total">
                    <div className="filters-top">
                        <h5>
                            <img
                                src="/images/right-arrow-long-black.svg"
                                alt="icon"
                                onClick={() => setDrawer(false)}
                            />
                            {dbCommercial.additionalPurchase.investmentPage.rightHeading}
                        </h5>
                        <a onClick={handleViewMore}>
                            {dbCommercial.additionalPurchase.investmentPage.viewMore}
                        </a>
                    </div>
                    <div className="filters-drawer-content">
                        <div className="profile-details-drawer">
                            <div className="profile-details">
                                <DisplayBlock
                                    title={dbCommercial.additionalPurchase.investmentPage.pan}
                                    value={`${props.pan}`}
                                />
                                <div className="profile-details-info">
                                    <h6> {`${additionalPurchaseFolio?.schemeName}`}</h6>
                                </div>
                            </div>
                            <SelectBank
                                amc={additionalPurchaseFolio?.amc}
                                folioNo={additionalPurchaseFolio?.folio}
                                handleBankDetails={setBankDetails}
                            />
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
            <NomineePopup folio={currentScheme.folio.toString()} />
            <NavDialog
                showNavDialog={showNavDialog}
                setShowNavDialog={setShowNavDialog}
                handleApInvest={handleInvest}
            />
        </div>
    );
}

export const RtaSchemeLoadingDialog = ({ open }: { open: boolean }) => {
    return (
        <Dialog maxWidth={'sm'} open={open} aria-labelledby="enable-fingerprint-modal">
            <div className="enable-fingerprint-modal">
                <CircularProgress />
                <p style={{ marginTop: '12px' }}>{'Fetching scheme details...'}</p>
            </div>
        </Dialog>
    );
};

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    {
        getCountries,
        getInvestorLatestDetails,
        getPortfolio,
        getFundTransactionInfo,
        sendPhoneOTP,
        makeAdditionalPurchase,
        getNewSchemeDetail,
    },
)(ApInvestment);
